import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCentralUnit = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5 3C5 2.44772 5.44772 2 6 2H18C18.5523 2 19 2.44772 19 3V21C19 21.5523 18.5523 22 18 22C17.4477 22 17 21.5523 17 21V20.5366H16V21C16 21.5523 15.5523 22 15 22C14.4477 22 14 21.5523 14 21V20.5366H10V21C10 21.5523 9.55228 22 9 22C8.44772 22 8 21.5523 8 21V20.5366H7V21C7 21.5523 6.55228 22 6 22C5.44772 22 5 21.5523 5 21V3ZM7 18.5366H11V9H7V18.5366ZM7 7H11V4H7V7ZM13 4V7H17V4H13ZM17 9H13V18.5366H17V9Z",
		fill: "currentColor"
	})
});
export default SvgCentralUnit;
